import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter } from "react-router-dom";
import Header from './../../Header';
import HeaderMob from './../../HeaderMob';
import $ from 'jquery';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
class EditSla extends Component {
    constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
            sla_info:[],
            message: '',
            redirect: false,
            apiUrl: this.decryptconfigdata('apiUrl'),
            visibility: 'public',
            plan:[],
            priority_type: [],
            responceunits:[],
            description:'',
            status: [],
            userAuthKey: has_local_data ? localdata.user_key : '',
            userId: has_local_data ? localdata.user_id : '',
            fields: {},
            errors: {},
            errorText: ''
        }
        this.updatesla = this.updatesla.bind(this);
        this.onChange = this.onChange.bind(this);  
    }
    decryptconfigdata(configkey) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {iv});
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return plaintext;
    }
    decrypt(findresponse, flg) {
        var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
        var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
        var res = flg ? findresponse.encdata : findresponse;
        var bytes = CryptoJS.AES.decrypt(res, key, {
            iv
        });
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        return JSON.parse(plaintext);
    }
    rawjsonparse(findresponse, flg) {
        return findresponse;
    }
    handleValidation() {
        let fields = this.state.sla_info;
        let errors = {};
        let formIsValid = true;
        /*********Initial Nearing Response Time***************/
        if(fields["initial_nearing_responce_units"]=='1'){
            var initial_nearing= fields["initial_nearing_responce_time"]*60;
        }else if(fields["initial_nearing_responce_units"]=='2'){
            var initial_nearing= fields["initial_nearing_responce_time"]*60*60;
        }else if(fields["initial_nearing_responce_units"]=='3'){
            var initial_nearing= fields["initial_nearing_responce_time"]*60*60*24;
        }else if(fields["initial_nearing_responce_units"]=='4'){
            var initial_nearing= fields["initial_nearing_responce_time"]*60*60*24*7;
        }
        if (!fields["initial_nearing_responce_time"]) {
            formIsValid = false;
            errors["initial_nearing_responce_time"] = "Initial Nearing Response Time Is Required.";
        }
        else if (fields["initial_nearing_responce_time"] && !this.isValidNumber(fields["initial_nearing_responce_time"])) {
            formIsValid = false;
            errors["initial_nearing_responce_time"] = "Please Provide Numbers Without Starting '0'.";   
        }
        else if (fields["initial_nearing_responce_time"]==0) {
            formIsValid = false;
            errors["initial_nearing_responce_time"] = "Please Provide Numbers Greater Than 0.";
        }
        /*********Initial Missed Response Time***************/
        if(fields["initial_missed_responce_units"]=='1'){
            var initial_missed= fields["initial_missed_responce_time"]*60;
        }else if(fields["initial_missed_responce_units"]=='2'){
            var initial_missed= fields["initial_missed_responce_time"]*60*60;
        }else if(fields["initial_missed_responce_units"]=='3'){
            var initial_missed= fields["initial_missed_responce_time"]*60*60*24;
        }else if(fields["initial_missed_responce_units"]=='4'){
            var initial_missed= fields["initial_missed_responce_time"]*60*60*24*7;
        }
        if (!fields["initial_missed_responce_time"]) {
            formIsValid = false;
            errors["initial_missed_responce_time"] = "Initial Missed Response Time Is Required.";
        }
        else if (fields["initial_missed_responce_time"] && !this.isValidNumber(fields["initial_missed_responce_time"])) {
            formIsValid = false;
            errors["initial_missed_responce_time"] = "Please Provide Numbers Without Starting '0'.";
        }
        else if (fields["initial_missed_responce_time"]==0) {
            formIsValid = false;
            errors["initial_missed_responce_time"] = "Please Provide Numbers Greater Than 0.";
        }
        /*********Updated Nearing Response Time***************/
        if(fields["updated_nearing_responce_units"]=='1'){
            var updated_nearing= fields["updated_nearing_responce_time"]*60;
        }else if(fields["updated_nearing_responce_units"]=='2'){
            var updated_nearing= fields["updated_nearing_responce_time"]*60*60;
        }else if(fields["updated_nearing_responce_units"]=='3'){
            var updated_nearing= fields["updated_nearing_responce_time"]*60*60*24;
        }else if(fields["updated_nearing_responce_units"]=='4'){
            var updated_nearing= fields["updated_nearing_responce_time"]*60*60*24*7;
        }
        else if (!fields["updated_nearing_responce_time"]) {
            formIsValid = false;
            errors["updated_nearing_responce_time"] = "Updated Nearing Response Time Is Required.";
        }        
        else if (fields["updated_nearing_responce_time"] && !this.isValidNumber(fields["updated_nearing_responce_time"])) {
            formIsValid = false;
            errors["updated_nearing_responce_time"] = "Please Provide Numbers Without Starting '0'.";
        }
        else if (fields["updated_nearing_responce_time"]==0) {
            formIsValid = false;
            errors["updated_nearing_responce_time"] = "Please Provide Numbers Greater Than 0.";
        }
        /*********Updated Missed Response Time***************/
        if(fields["updated_missed_responce_units"]=='1'){
            var updated_missed= fields["updated_missed_responce_time"]*60;
        }else if(fields["updated_missed_responce_units"]=='2'){
            var updated_missed= fields["updated_missed_responce_time"]*60*60;
        }else if(fields["updated_missed_responce_units"]=='3'){
            var updated_missed= fields["updated_missed_responce_time"]*60*60*24;
        }else if(fields["updated_missed_responce_units"]=='4'){
            var updated_missed= fields["updated_missed_responce_time"]*60*60*24*7;
        }
        else if (!fields["updated_missed_responce_time"]) {
            formIsValid = false;
            errors["updated_missed_responce_time"] = "Updated Missed Response Time Is Required.";
        }
        else if (fields["updated_missed_responce_time"] && !this.isValidNumber(fields["updated_missed_responce_time"])) {
            formIsValid = false;
            errors["updated_missed_responce_time"] = "Please Provide Numbers Without Starting '0'.";
        }
        else if (fields["updated_missed_responce_time"]==0) {
            formIsValid = false;
            errors["updated_missed_responce_time"] = "Please Provide Numbers Greater Than 0.";
        }
        /*********Comparison Validation**********/
        else if(initial_nearing >= initial_missed){
            formIsValid = false;
            errors["initial_missed_responce_time"] = "Initial Nearing Response Time Can't Equal Or Greater Than Initial Missed Response Time.";
        }
        else if(updated_nearing >= updated_missed){
            formIsValid = false;
            errors["updated_missed_responce_time"] = "Updated Nearing Response Time Can't Equal Or Greater Than Updated Missed Response Time.";
        }
        else if(initial_nearing >= updated_nearing){
            formIsValid = false;
            errors["initial_missed_responce_time"] = "Initial Nearing Response Time Can't Equal Or Greater Than Updated Nearing Response Time.";
        }
        else if(initial_missed >= updated_missed){
            formIsValid = false;
            errors["updated_missed_responce_time"] = "Initial Missed Response Time Can't Equal Or Greater Than Updated Missed Response Time.";
        }
        else if (!fields["description"]) {
            formIsValid = false;
            errors["description"] = "Description Is Required.";
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    isValidNumber(number) {
        var pattern = /^(?:[1-9]\d*|0)$/;
        return pattern.test(number);
    }
    updatesla() {
        if (this.handleValidation()) {

        } else {
           return false;
        }
        document.getElementById("updatesla").innerHTML = "Sending....";
        const fd = new FormData;
        document.getElementById("updatesla").disabled = true;
        fd.append('slainputs', JSON.stringify(this.state.sla_info));
        fetch(this.state.apiUrl + '/SlaRest/UpdateSla/sla_id/' + this.props.match.params.slaId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey,{
            method: 'POST',
            dataType: 'json',
            body: fd,
        })
        .then((Response) => Response.json())
        .then((findresponse) => {
            findresponse = this.rawjsonparse(findresponse, 1);
            document.getElementById("updatesla").innerHTML = "Submit";
            if (findresponse.code == 1) {
                this.setState({ message: findresponse.msg }, function () {
                    window.location.href = '/SlaList';
                });
            }
            
        })
    }
    onChange(propertyName, event) {
        let sla_info = this.state.sla_info;
        sla_info[propertyName] = event.target.value;
        this.setState({ sla_info: sla_info });
    }
    GetSlaParameters() {
        fetch(this.state.apiUrl + '/SlaRest/GetSlaConfig/userAuthKey/'+ this.state.userAuthKey, {
            method: 'POST',
            dataType: 'json',
            body: JSON.stringify(this.state),
        })
        .then((Response) => Response.json())
        .then((findresponse) => {
            findresponse = this.rawjsonparse(findresponse, 1);
            this.setState({
                plan: findresponse.plan,
                priority_type: findresponse.priority_type,
                responceunits: findresponse.responceunits,
                status: findresponse.status,
            })
        })
    }
    getSlaDetails() {
    fetch(this.state.apiUrl + '/SlaRest/EditSla/sla_id/' + this.props.match.params.slaId + '/userId/' + this.state.userId + '/userAuthKey/' + this.state.userAuthKey,{
                method: 'POST',
                dataType: 'json',
                body: JSON.stringify(this.state),
            })
        .then((Response) => Response.json())
        .then((responseJson) => {
            responseJson = this.rawjsonparse(responseJson, 1);
            this.setState({
                sla_info: responseJson.sla_info
            })
        })    
    }
    componentDidMount() {
        document.title = "Intranet | Edit SLA";
        if (!localStorage.getItem('userLogin')) {
            this.setState({ redirect: true });
        }
        this.GetSlaParameters();
        this.getSlaDetails();
    }
    render() {
        if (this.state.redirect) {
            return (
                <Redirect to={'/login'}/>
            )
        }
        return (
            <div>
                <Header brecum_name="Edit SLA" brecum_page="Edit SLA" />
                <div class="right_col">
                    <span className="error">{this.state.error_message}</span>
                    <div class="intranet_body" id="add_sla_form">
                        <div class="title mob"><HeaderMob page_name="Edit SLA" /></div>
                        <div class="form-group"></div>
                        <div class="form-section add row">
                            <div className="form-group col-md-4 col-xs-4">
                                <label>Plan Type</label>
                                <select class="form-control" value={this.state.sla_info.plan} name="plan" id="plan" onChange={this.onChange.bind(this, 'plan')} >
                                    {
                                        this.state.plan.map((dynamicData, index) =>
                                            <option value={dynamicData.value}>{dynamicData.value}</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div className="form-group col-md-4 col-xs-4">
                                <label>Priority</label>
                                <select class="form-control" value={this.state.sla_info.priority_type} name="priority_type" id="priority_type" onChange={this.onChange.bind(this, 'priority_type')} >
                                    {
                                        this.state.priority_type.map((dynamicData, index) =>
                                            <option value={dynamicData.value}>{dynamicData.value}</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div class="form-group col-md-4 col-xs-4">
                                <label>Status</label>
                                <select value={this.state.sla_info.status == 1 ? 1 : 2} class="form-control" name="slastatus" id="slastatus" onChange={this.onChange.bind(this, 'status')} >
                                    {
                                        this.state.status.map((dynamicData, index) =>
                                            <option value={dynamicData.key}>{dynamicData.value}</option>
                                        )
                                    }
                                </select>
                        </div>
                        </div>
                        <div class="form-section add row">
                            <div className="form-group col-md-4 col-xs-4">
                                <label>Initial Nearing Response Time<span class="star">*</span></label>
                                <input type="text" value={this.state.sla_info.initial_nearing_responce_time} name="initial_nearing_responce_time" id="initial_nearing_responce_time" className="form-control" onChange={this.onChange.bind(this, 'initial_nearing_responce_time')} />
                                <span class="error">{this.state.errors["initial_nearing_responce_time"]}</span>
                            </div>
                            <div className="form-group col-md-2 col-xs-2">
                            <label>&nbsp;</label>
                                    <select class="form-control" value={this.state.sla_info.initial_nearing_responce_units} name="initial_nearing_responce_units" id="initial_nearing_responce_units" onChange={this.onChange.bind(this, 'initial_nearing_responce_units')} >
                                    {
                                        this.state.responceunits.map((dynamicData, index) =>
                                            <option value={dynamicData.key}>{dynamicData.value+'(s)'}</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div className="form-group col-md-4 col-xs-4">
                                <label>Initial Missed Response Time<span class="star">*</span></label>
                                <input type="text" value={this.state.sla_info.initial_missed_responce_time} name="initial_missed_responce_time" id="initial_missed_responce_time" className="form-control" onChange={this.onChange.bind(this, 'initial_missed_responce_time')} />
                                <span class="error">{this.state.errors["initial_missed_responce_time"]}</span>
                            </div>
                            <div className="form-group col-md-2 col-xs-2">
                                <label>&nbsp;</label>
                                    <select class="form-control" value={this.state.sla_info.initial_missed_responce_units} name="initial_missed_responce_units" id="initial_missed_responce_units" onChange={this.onChange.bind(this, 'initial_missed_responce_units')} >
                                        {
                                            this.state.responceunits.map((dynamicData, index) =>
                                                <option value={dynamicData.key}>{dynamicData.value+'(s)'}</option>
                                            )
                                        }
                                    </select>
                            </div>
                        </div>
                        <div class="form-section add row">
                            <div className="form-group col-md-4 col-xs-4">
                                <label>Updated Nearing Response Time<span class="star">*</span></label>
                                <input type="text" value={this.state.sla_info.updated_nearing_responce_time} name="updated_nearing_responce_time" id="updated_nearing_responce_time" className="form-control" onChange={this.onChange.bind(this, 'updated_nearing_responce_time')}/>
                                <span class="error">{this.state.errors["updated_nearing_responce_time"]}</span>
                            </div>
                            <div className="form-group col-md-2 col-xs-6">
                            <label>&nbsp;</label>
                                    <select class="form-control" value={this.state.sla_info.updated_nearing_responce_units} name="updated_nearing_responce_units" id="updated_nearing_responce_units" onChange={this.onChange.bind(this, 'updated_nearing_responce_units')} >
                                    {
                                        this.state.responceunits.map((dynamicData, index) =>
                                            <option value={dynamicData.key}>{dynamicData.value+'(s)'}</option>
                                        )
                                    }
                                </select>
                            </div>
                            <div className="form-group col-md-4 col-xs-4">
                                <label>Updated Missed Response Time<span class="star">*</span></label>
                                <input type="text" value={this.state.sla_info.updated_missed_responce_time} name="updated_missed_responce_time" id="updated_missed_responce_time" className="form-control" onChange={this.onChange.bind(this, 'updated_missed_responce_time')}/>
                                <span class="error">{this.state.errors["updated_missed_responce_time"]}</span>
                            </div>
                            <div className="form-group col-md-2 col-xs-6">
                                <label>&nbsp;</label>
                                    <select class="form-control" value={this.state.sla_info.updated_missed_responce_units} name="updated_missed_responce_units" id="updated_missed_responce_units" onChange={this.onChange.bind(this, 'updated_missed_responce_units')} >
                                    {
                                            this.state.responceunits.map((dynamicData, index) =>
                                                <option value={dynamicData.key}>{dynamicData.value+'(s)'}</option>
                                        )
                                    }
                                </select>
                            </div>
                        </div>
                        <div class="form-section add row">
                            <div class="form-group col-md-12 col-xs-12">
                                <label>Description</label>
                            <textarea class="form-control" name="description" id="description" value={this.state.sla_info.description} onChange={this.onChange.bind(this, 'description')}></textarea>
                            <span class="error">{this.state.errors["description"]}</span>
                            </div>
                        </div>
                        <button type="submit" name="updatesla" id="updatesla" class="btn btn-sky mob-btn" onClick={() => this.updatesla()}>Submit</button>
                        <Link to={`/SlaList/`} name={"max"}> <button className="btn btn-blue" >Back</button></Link>
                    </div>
                </div>
            </div>
        )
    }
}
export default EditSla;


// WEBPACK FOOTER //
// ./src/components/sla/EditSla.js